/* LUMINA KOREA — theme scripts */
(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  var routes = window.Theme && window.Theme.routes ? window.Theme.routes : {};
  var strings = window.Theme && window.Theme.strings ? window.Theme.strings : {};

  /* ---------- Helpers ---------- */
  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }

  function toast(message) {
    var el = qs('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 3600);
  }

  /* ---------- Focus trap & drawers ---------- */
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;

  function openDrawer(id, trigger) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    lastTrigger = trigger || document.activeElement;
    qsa('.drawer.is-open').forEach(function (d) {
      if (d !== drawer) closeDrawer(d, true);
    });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    root.classList.add('drawer-open');
    qsa('[aria-controls="' + id + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    var focusTarget = qs('[data-autofocus]', drawer) || qs(FOCUSABLE, qs('.drawer__panel', drawer));
    if (focusTarget) {
      setTimeout(function () {
        focusTarget.focus();
      }, 60);
    }
  }

  function closeDrawer(drawer, silent) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    root.classList.remove('drawer-open');
    qsa('[aria-controls="' + drawer.id + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (!silent && lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'), opener);
      return;
    }
    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (event) {
    var open = qs('.drawer.is-open');
    if (!open) return;
    if (event.key === 'Escape') {
      closeDrawer(open);
      return;
    }
    if (event.key === 'Tab') {
      var items = qsa(FOCUSABLE, qs('.drawer__panel', open)).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- Sticky header ---------- */
  /* Lê o cabeçalho actual em cada evento: continua a funcionar depois de o
     cabeçalho ser alterado no editor do tema (a secção é renderizada de novo). */
  var headerState = { wrapper: null, section: null, mode: 'none', lastY: window.scrollY };
  function onHeaderScroll() {
    var w = headerState.wrapper;
    if (!w || !document.body.contains(w)) return;
    var y = window.scrollY;
    w.classList.toggle('is-scrolled', headerState.mode !== 'none' && y > 8);
    if (headerState.mode === 'scroll_up' && headerState.section) {
      var menuOpen = root.classList.contains('drawer-open');
      var goingDown = y > headerState.lastY;
      var pastHeader = y > headerState.section.offsetHeight + 40;
      headerState.section.classList.toggle('is-header-hidden', goingDown && pastHeader && !menuOpen);
    }
    headerState.lastY = y;
  }
  function initHeader() {
    var w = qs('.section-header-wrapper');
    headerState.wrapper = w;
    headerState.mode = w ? w.getAttribute('data-sticky-mode') || 'none' : 'none';
    headerState.section = w ? w.closest('.section-site-header') || w.parentElement : null;
    if (headerState.section && headerState.mode !== 'scroll_up') headerState.section.classList.remove('is-header-hidden');
    headerState.lastY = window.scrollY;
    onHeaderScroll();
  }
  window.addEventListener('scroll', onHeaderScroll, { passive: true });

  /* ---------- Avaliações: abrir formulário e ver mais ---------- */
  function initReviews(scope) {
    qsa('[data-product-reviews]', scope).forEach(function (root) {
      if (root.__luminaInit) return;
      root.__luminaInit = true;
      var toggle = root.querySelector('[data-review-toggle]');
      var wrapper = root.querySelector('[data-review-form]');
      if (toggle && wrapper) {
        if (!wrapper.hasAttribute('hidden')) toggle.setAttribute('aria-expanded', 'true');
        toggle.addEventListener('click', function () {
          var open = wrapper.hasAttribute('hidden');
          if (open) {
            wrapper.removeAttribute('hidden');
            toggle.setAttribute('aria-expanded', 'true');
            var first = wrapper.querySelector('input:not([type="hidden"]), textarea');
            wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
            if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
          } else {
            wrapper.setAttribute('hidden', '');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
      var more = root.querySelector('[data-review-more]');
      if (more) {
        more.addEventListener('click', function () {
          qsa('[data-review-extra]', root).forEach(function (el) {
            el.removeAttribute('hidden');
            el.removeAttribute('data-review-extra');
          });
          more.parentElement.remove();
        });
      }
    });
  }

  /* ---------- Avaliações: etiqueta da classificação ---------- */
  function initStars(scope) {
    qsa('[data-star-input]', scope).forEach(function (group) {
      if (group.__luminaInit) return;
      group.__luminaInit = true;
      var label = group.parentElement.querySelector('[data-star-label]');
      if (!label) return;
      var initial = label.textContent;
      function update(input) {
        label.textContent = input ? input.getAttribute('data-label') : initial;
        label.classList.toggle('is-set', !!input);
      }
      group.addEventListener('change', function (event) {
        if (event.target.matches('input[type="radio"]')) update(event.target);
      });
    });
  }

  /* ---------- Desktop dropdowns: close on outside click ---------- */
  document.addEventListener('click', function (event) {
    qsa('.site-nav__dropdown[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Announcement bar rotation ---------- */
  function initAnnouncement(scope) {
    qsa('[data-announcement]', scope).forEach(function (bar) {
      if (bar.__luminaInit) return;
      bar.__luminaInit = true;
      var slides = qsa('.announcement-bar__message', bar);
      if (slides.length < 2) return;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5;
      var i = 0;
      slides.forEach(function (sl, n) {
        if (sl.classList.contains('is-active')) i = n;
      });
      function next() {
        if (!document.body.contains(bar)) {
          clearInterval(bar.__timer);
          return;
        }
        slides[i].classList.remove('is-active');
        slides[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
        slides[i].setAttribute('aria-hidden', 'false');
      }
      bar.__timer = setInterval(next, speed * 1000);
      bar.addEventListener('mouseenter', function () {
        clearInterval(bar.__timer);
      });
      bar.addEventListener('mouseleave', function () {
        clearInterval(bar.__timer);
        bar.__timer = setInterval(next, speed * 1000);
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(scope) {
    if (!root.classList.contains('reveal-on-scroll')) return;
    var items = qsa('.reveal:not(.is-visible)', scope);
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }
  initReveal(document);

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-change]');
    if (!btn) return;
    event.preventDefault();
    var wrapper = btn.closest('.quantity');
    var input = qs('input', wrapper);
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  var cartSections = function () {
    var ids = [];
    qsa('[data-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-cart-section');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  };

  function renderCartSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = parseHTML(html);
      qsa('[data-cart-section="' + id + '"]').forEach(function (target) {
        var source = qs('[data-cart-section="' + id + '"]', doc);
        if (source) target.innerHTML = source.innerHTML;
      });
    });
  }

  function cartOpen() {
    if (root.getAttribute('data-cart-type') === 'drawer' && document.getElementById('CartDrawer')) {
      openDrawer('CartDrawer');
    } else {
      window.location.href = routes.cart_url || '/cart';
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    if (root.getAttribute('data-cart-type') !== 'drawer') return;
    event.preventDefault();
    var button = qs('[type="submit"]', form);
    if (button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
    }
    var data = new FormData(form);
    data.append('sections', cartSections().join(','));
    data.append('sections_url', window.location.pathname);

    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          toast(res.description || res.message || strings.error);
          return;
        }
        renderCartSections(res.sections);
        cartOpen();
      })
      .catch(function () {
        toast(strings.error);
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          button.removeAttribute('aria-disabled');
        }
      });
  });

  function changeLine(line, quantity, scope) {
    if (scope) scope.classList.add('is-updating');
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: cartSections(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          toast(res.description || res.message || strings.error);
        }
        renderCartSections(res.sections);
      })
      .catch(function () {
        toast(strings.error);
      })
      .finally(function () {
        if (scope) scope.classList.remove('is-updating');
      });
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-line-qty]');
    if (!input) return;
    clearTimeout(input._qtyTimer);
    input._qtyTimer = setTimeout(function () {
      changeLine(parseInt(input.getAttribute('data-cart-line-qty'), 10), parseInt(input.value, 10) || 0, input.closest('.cart-item'));
    }, 350);
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    changeLine(parseInt(remove.getAttribute('data-cart-remove'), 10), 0, remove.closest('.cart-item'));
  });

  /* ---------- Variant picker (Section Rendering API) ---------- */
  document.addEventListener('change', function (event) {
    var picker = event.target.closest('[data-variant-picker]');
    if (!picker) return;
    var section = picker.closest('[data-product-section]');
    var url = picker.getAttribute('data-url');
    var sectionId = section.getAttribute('data-section-id');
    var values = qsa('input:checked, select', picker)
      .map(function (el) {
        return el.tagName === 'SELECT' ? el.selectedOptions[0].getAttribute('data-option-value-id') : el.getAttribute('data-option-value-id');
      })
      .filter(Boolean)
      .join(',');

    section.classList.add('is-updating');
    fetch(url + '?section_id=' + encodeURIComponent(sectionId) + '&option_values=' + values)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = parseHTML(html);
        var focusedId = document.activeElement && document.activeElement.id;
        qsa('[data-variant-update]', section).forEach(function (target) {
          var key = target.getAttribute('data-variant-update');
          var source = qs('[data-variant-update="' + key + '"]', doc);
          if (source) target.innerHTML = source.innerHTML;
        });
        if (focusedId) {
          var refocus = document.getElementById(focusedId);
          if (refocus) refocus.focus();
        }
        var variantJson = qs('[data-selected-variant]', doc);
        if (variantJson) {
          try {
            var variant = JSON.parse(variantJson.textContent);
            if (variant && variant.id) {
              qsa('input[name="id"]', section).forEach(function (input) {
                input.value = variant.id;
              });
              var newUrl = url + '?variant=' + variant.id;
              window.history.replaceState({}, '', newUrl);
              if (variant.featured_media) {
                var media = qs('[data-media-id="' + variant.featured_media.id + '"]', section);
                if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
              }
            }
          } catch (e) {}
        }
      })
      .finally(function () {
        section.classList.remove('is-updating');
      });
  });

  /* ---------- Sticky buy bar (mobile) ---------- */
  function initStickyBar(scope) {
    qsa('[data-sticky-bar]', scope).forEach(function (bar) {
      if (bar.__luminaInit) return;
      bar.__luminaInit = true;
      var section = bar.closest('[data-product-section]');
      var target = section && qs('[data-variant-update="buy"]', section);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var below = entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', !entry.isIntersecting && below);
        });
      }).observe(target);
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb-target]');
    if (!thumb) return;
    event.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    var target = qs('[data-media-id="' + thumb.getAttribute('data-thumb-target') + '"]', gallery);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    qsa('[data-thumb-target]', gallery).forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });

  /* ---------- Predictive search ---------- */
  function initPredictive(scope) {
    qsa('[data-predictive-search]', scope).forEach(function (form) {
      if (form.__luminaInit) return;
      form.__luminaInit = true;
      var input = qs('input[type="search"]', form);
      var results = qs('[data-predictive-results]', form.closest('.drawer__panel') || form.parentNode);
      if (!input || !results) return;
      var controller;
      input.addEventListener(
        'input',
        debounce(function () {
          var term = input.value.trim();
          if (term.length < 2) {
            results.innerHTML = '';
            return;
          }
          if (controller) controller.abort();
          controller = 'AbortController' in window ? new AbortController() : null;
          var url =
            (routes.predictive_search_url || '/search/suggest') +
            '?q=' +
            encodeURIComponent(term) +
            '&section_id=predictive-search&resources[limit]=6&resources[type]=product,collection,page,article';
          fetch(url, controller ? { signal: controller.signal } : {})
            .then(function (r) {
              return r.text();
            })
            .then(function (html) {
              var doc = parseHTML(html);
              var content = qs('#shopify-section-predictive-search', doc);
              results.innerHTML = content ? content.innerHTML : '';
            })
            .catch(function () {});
        }, 280)
      );
    });
  }

  /* ---------- Auto-submit forms (localization, filters, sort) ---------- */
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el.closest('[data-auto-submit]')) return;
    var form = el.closest('form');
    if (form) form.submit();
  });

  /* ---------- Share button ---------- */
  document.addEventListener('click', function (event) {
    var share = event.target.closest('[data-share]');
    if (!share) return;
    event.preventDefault();
    var url = share.getAttribute('data-share');
    if (navigator.share) {
      navigator.share({ url: url, title: document.title }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        toast(strings.link_copied);
      });
    }
  });

  /* ---------- Cookie banner (Shopify Customer Privacy API) ---------- */
  function initCookies(scope) {
    qsa('[data-cookie-banner]', scope).forEach(function (banner) {
      if (banner.__luminaInit) return;
      banner.__luminaInit = true;
      var always = banner.getAttribute('data-always') === 'true';
      var KEY = 'lumina-cookie-consent-v2'; /* v2: novo tema — o aviso volta a aparecer a todos uma vez */
      var prefs = banner.querySelector('[data-cookie-prefs]');
      var toggle = banner.querySelector('[data-cookie-toggle]');
      var saveBtn = banner.querySelector('[data-cookie-save]');
      var analyticsInput = banner.querySelector('[data-cookie-analytics]');
      var marketingInput = banner.querySelector('[data-cookie-marketing]');

      function stored() {
        try {
          var raw = window.localStorage.getItem(KEY);
          return raw ? JSON.parse(raw) : null;
        } catch (e) {
          return null;
        }
      }
      function store(value) {
        try {
          window.localStorage.setItem(KEY, JSON.stringify(value));
        } catch (e) {}
      }
      function privacy() {
        return window.Shopify && window.Shopify.customerPrivacy;
      }
      function apply(choice) {
        var cp = privacy();
        if (cp && cp.setTrackingConsent) {
          cp.setTrackingConsent(
            {
              analytics: choice.analytics,
              marketing: choice.marketing,
              preferences: choice.analytics,
              sale_of_data: choice.marketing
            },
            function () {}
          );
        }
      }
      function decide(choice) {
        choice.date = new Date().toISOString();
        store(choice);
        apply(choice);
        close();
      }
      function setPrefsOpen(open) {
        if (!prefs) return;
        prefs.hidden = !open;
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (saveBtn) saveBtn.hidden = !open;
        banner.classList.toggle('is-expanded', open);
      }
      function open(showPrefs) {
        var current = stored();
        if (analyticsInput) analyticsInput.checked = current ? !!current.analytics : false;
        if (marketingInput) marketingInput.checked = current ? !!current.marketing : false;
        banner.hidden = false;
        setPrefsOpen(!!showPrefs);
      }
      function close() {
        banner.hidden = true;
        setPrefsOpen(false);
      }

      banner.addEventListener('click', function (event) {
        if (event.target.closest('[data-cookie-accept]')) decide({ analytics: true, marketing: true });
        if (event.target.closest('[data-cookie-decline]')) decide({ analytics: false, marketing: false });
        if (event.target.closest('[data-cookie-save]')) {
          decide({
            analytics: !!(analyticsInput && analyticsInput.checked),
            marketing: !!(marketingInput && marketingInput.checked)
          });
        }
        if (event.target.closest('[data-cookie-toggle]')) setPrefsOpen(prefs ? prefs.hidden : false);
      });

      banner.__open = open;

      function init() {
        if (window.Shopify && window.Shopify.designMode) {
          /* No editor de temas o aviso fica escondido para não tapar a página;
             aparece só quando a secção de cookies é seleccionada. */
          close();
          return;
        }
        var current = stored();
        if (current) {
          apply(current);
          close();
          return;
        }
        var cp = privacy();
        var show = true;
        if (!always && cp && cp.shouldShowBanner) {
          show = cp.shouldShowBanner();
        }
        if (show) open(false);
        else close();
      }
      if (window.Shopify && window.Shopify.designMode) {
        close();
        return;
      }
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          init();
        });
      } else {
        init();
      }
    });
  }

  /* Link "Definições de cookies" no rodapé: abre sempre o aviso actual. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cookie-open]')) return;
    var banner = qs('[data-cookie-banner]');
    if (banner && banner.__open) {
      event.preventDefault();
      banner.__open(true);
    }
  });

  /* ---------- Inicialização (página e editor do tema) ---------- */
  function initScope(scope) {
    initReviews(scope);
    initStars(scope);
    initAnnouncement(scope);
    initStickyBar(scope);
    initPredictive(scope);
    initCookies(scope);
  }
  initHeader();
  initScope(document);

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
    initHeader();
    var cookie = event.target.querySelector('[data-cookie-banner]');
    if (cookie) cookie.hidden = false; /* secção acabada de editar: mostrar */
    initReveal(event.target);
    qsa('.reveal', event.target).forEach(function (el) {
      el.classList.add('is-visible');
    });
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
    var cookie = event.target.querySelector('[data-cookie-banner]');
    if (cookie) cookie.hidden = false;
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    if (event.target.querySelector('#CartDrawer')) closeDrawer(document.getElementById('CartDrawer'), true);
    var cookie = event.target.querySelector('[data-cookie-banner]');
    if (cookie) cookie.hidden = true;
  });

  document.addEventListener('shopify:section:unload', function (event) {
    qsa('[data-announcement]', event.target).forEach(function (bar) {
      clearInterval(bar.__timer);
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('.announcement-bar__message');
    if (slide) {
      qsa('.announcement-bar__message', slide.parentNode).forEach(function (s) {
        s.classList.toggle('is-active', s === slide);
      });
    }
    var accordion = event.target.closest('details');
    if (accordion) accordion.setAttribute('open', '');
  });
})();
